const PUBLIC_URL = process.env.REACT_APP_MOBILE_CDN_BASE_URL || "";

export function mobileImage(name) {
    return `${PUBLIC_URL}/mobile/images/${name}`;
}
